import { ReactNode, useEffect } from 'react'
import { Navigate, useLocation } from 'react-router-dom'
import { Center, Loader, Alert } from '@mantine/core'
import { IconShieldX } from '@tabler/icons-react'
import { useAuth } from '@/hooks/useAuth'

interface AdminRouteProps {
    children: ReactNode
}

export const AdminRoute: React.FC<AdminRouteProps> = ({ children }) => {
    const { isAuthenticated, isAdmin, isLoading } = useAuth()
    const location = useLocation()

    useEffect(() => {
        // Store the intended destination when user is not authenticated
        if (!isLoading && !isAuthenticated) {
            const intendedPath = location.pathname + location.search + location.hash
            localStorage.setItem('redirectAfterAuth', intendedPath)
        }
    }, [isAuthenticated, isLoading, location])

    if (isLoading) {
        return (
            <Center h={200}>
                <Loader size="lg" />
            </Center>
        )
    }

    if (!isAuthenticated) {
        return <Navigate to="/login" replace />
    }

    if (!isAdmin) {
        return (
            <Center p="xl">
                <Alert
                    icon={<IconShieldX size={16} />}
                    title="Access Denied"
                    color="red"
                    variant="light"
                >
                    You don't have permission to access this area.
                </Alert>
            </Center>
        )
    }

    return <>{children}</>
} 